import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { auth } from "../config/firebaseConfig";
import { useAuthState } from "react-firebase-hooks/auth";
import { LoadingDots } from "../components";
import { useSelector } from "react-redux";
const UserAuthProtected = ({ children, authenticate = true }) => {
  const [userAuth, authLoading] = useAuthState(auth);
  const navigate = useNavigate();
  const location = useLocation();
  const { userDetails, loading: userDetailsLoading } = useSelector(
    (state) => state.auth
  );

  useEffect(() => {
    if (!authLoading) {
      if (authenticate && !userAuth) {
        navigate("/login");
      } else if (!authenticate && userAuth) {
        if (userDetailsLoading) {
        } else {
          const searchParams = new URLSearchParams(location.search);
          const isAiLab = searchParams.get("source") === "ai-lab";
          
          userDetails?.accountType === "school"
            ? navigate("/schoolDashboard")
            : (userDetails?.accountType === "parent" || userDetails?.accountType === "student")
            ? navigate(isAiLab ? "/dashboard?offer=ai-lab" : "/dashboard")
            : console.log("test");
        }
      }
    }
  }, [
    authenticate,
    navigate,
    authLoading,
    userAuth,
    userDetails,
    userDetailsLoading,
    location.search,
  ]);

  return authLoading || (userDetailsLoading && authenticate) ? <LoadingDots /> : children;
};

export default UserAuthProtected;
